import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Loyaltic } from './api-url.constants';

@Injectable({
  providedIn: 'root'
})
export class CoreService {

  logoUrl = '';

  constructor(private http: HttpClient) { }

  registerWithMobile(body) {
    return this.http.post(environment.baseUrl + Loyaltic.API.RegisterWithMobile, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  registerWithEmail(body) {
    return this.http.post(environment.baseUrl + Loyaltic.API.RegisterWithEmail, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }


  checkNickNameExists(name) {
    return this.http.post(environment.baseUrl + Loyaltic.API.NicknameExists + '?NickName=' + name, null)
      .toPromise().then(response => {
        return response;
      }).catch((error: HttpErrorResponse) => {
        return error.error;
      });
  }

  captureNickName(body) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureNickName, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  getAvailableGames(userId) {
    return this.http.get(environment.baseUrl + Loyaltic.API.AvailableGames + '?userid=' + userId)
      .toPromise().then(response => {
        return response;
      });
  }

  getPlayDetails(userId) {
    return this.http.get(environment.baseUrl + Loyaltic.API.Play + '?userid=' + userId)
      .toPromise().then(response => {
        return response;
      });
  }

  play(userId, uniqueCode) {
    return this.http.get(environment.baseUrl + Loyaltic.API.Play + '?userid=' + userId + '&uniqueCode=' +uniqueCode)
      .toPromise().then(response => {
        return response;
      });
  }

  getRanking() {
    return this.http.post(environment.baseUrl + Loyaltic.API.Ranking, {})
      .toPromise().then(response => {
        return response;
      });
  }

  getCombinedRanking(rankingType:any, dateSelectedString:string, chainName:string) {
    if (dateSelectedString != '') {
      if (chainName === null) {
        return this.http.get(environment.baseUrl + Loyaltic.API.CombinedRanking + '?rankingType=' +rankingType+ '&dateSelectedString=' +dateSelectedString, {})
        .toPromise().then(response => {
          return response;
        });
      } else {
        return this.http.get(environment.baseUrl + Loyaltic.API.CombinedRanking + '?rankingType=' +rankingType+ '&dateSelectedString=' +dateSelectedString+ '&chain=' +chainName, {})
        .toPromise().then(response => {
          return response;
        });
      }
    } else {
      if(chainName === null) {
        return this.http.get(environment.baseUrl + Loyaltic.API.CombinedRanking + '?rankingType=' +rankingType, {})
        .toPromise().then(response => {
          return response;
        });
      } else {
        return this.http.get(environment.baseUrl + Loyaltic.API.CombinedRanking + '?rankingType=' +rankingType+ '&chain='+chainName, {})
        .toPromise().then(response => {
          return response;
        });
      }
    }
    
  }

  getTournamentDetails(id:string) {
    return this.http.post(environment.baseUrl + Loyaltic.API.GetTournamentDetails +  '?id=' + id, {})
      .toPromise().then(response => {
        return response;
      });
  }

  deleteTournament(id:string) {
    return this.http.post(environment.baseUrl + Loyaltic.API.DeleteTournament +  '?tournamentId=' + id, {})
      .toPromise().then(response => {
        return response;
      });
  }


  removeUser(userId:string, tournamentId:string) {
    return this.http.post(environment.baseUrl + Loyaltic.API.RemoveUserFromTournament +  '?TournamentId=' + tournamentId + '&UserId=' +userId, {})
      .toPromise().then(response => {
        return response;
      });
  }

  forgotPassword(email) {
    return this.http.post(environment.baseUrl + Loyaltic.API.ForgotPassword, JSON.stringify({ Email: email }))
      .toPromise().then(response => {
        return response;
      });
  }

  resetPassword(body) {
    return this.http.post(environment.baseUrl + Loyaltic.API.ResetPassword, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  leaveTournament(tournamentId:string) {
    return this.http.post(environment.baseUrl + Loyaltic.API.LeaveTournament +  '?TournamentId=' + tournamentId, {})
      .toPromise().then(response => {
        return response;
      });
  }

  fbShareSuccess(userId) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Ranking + '?UserId=' + userId, null)
      .toPromise().then(response => {
        return response;
      });
  }

  getWinners() {
    return this.http.get(environment.baseUrl + Loyaltic.API.Winners)
      .toPromise().then(response => {
        return response;
      });
  }

  getAddressDetails(id) {
    return this.http.get(environment.baseUrl + Loyaltic.API.Address + '?id=' + id)
      .toPromise().then(response => {
        return response;
      });
  }

  updateAddress(body) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Address, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  submitCashback(body) {
    return this.http.post(environment.baseUrl + Loyaltic.API.SubmitCashback, body)
      .toPromise().then(response => {
        return response;
      });
  }

  getLiveConfig() {
    return this.http.get(environment.baseUrl + Loyaltic.API.LiveConfig)
      .toPromise().then(response => {
        return response;
      });
  }


  getTournaments(id) {
    return this.http.post(environment.baseUrl + Loyaltic.API.GetTournamenrs+ '?userId=' + id, {})
      .toPromise().then(response => {
        return response;
      });
  }

  getStores(chain) {
    return this.http.get(environment.baseUrl + Loyaltic.API.GetStores+ '?chain=' + chain)
      .toPromise().then(response => {
        return response;
      });
  }

  emailReminder(body: any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureEmail, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  signUp(userName) {
    return this.emailReminder({ Email: userName });
  }

  userExists(userName) {
    return this.http.post(environment.baseUrl + Loyaltic.API.UserExists+ '?email=' + userName, {})
      .toPromise().then(response => {
        return response;
      });
  }

  createTournament(userId:string, tournamentName:string, startDate:string, endDate:string) {
    let data = {
      UserId: userId,
      StartDate: startDate,
      EndDate: endDate,
      TournamentName: tournamentName
    }
    return this.http.post(environment.baseUrl + Loyaltic.API.CreateTournament, JSON.stringify(data))
      .toPromise().then(response => {
        return response;
      });
  }

  joinTournament(userId:string, tournamentId:string, code:string) {
    let data = {
      UserId: userId,
      UniqueCode: code,
      TournamentId: tournamentId
    }
    return this.http.post(environment.baseUrl + Loyaltic.API.JoinTournament, JSON.stringify(data))
      .toPromise().then(response => {
        return response;
      });
  }

  captureImage(payload, UserId) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureImage + '?UserId=' + UserId, payload)
      .toPromise().then(response => {
        return response;
      });
  }

  instantWinPlay(userId:any, playType:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.InstantWinPlay, JSON.stringify({ UserId: userId, PlaySource: playType }))
      .toPromise().then(response => {
        return response;
      });
  }

  captureAddress(body:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureAddress, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  captureDigitalWin(payload:any) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureDigitalWin , JSON.stringify(payload))
      .toPromise().then(response => {
        return response;
      });
  }

}
